import React from "react";
import { FaGithub, FaLinkedin, FaTwitter, FaEnvelope } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const goToProjects = () => {
    navigate('/', { state: { scrollTo: 'projects' } });
  };
  return (
    <footer className="bg-[#c3f7f7] text-black pt-10 pb-4">
      {/* Main footer sections */}
      <div className="max-w-6xl mx-auto px-6 text-center sm:text-left grid grid-cols-1 md:grid-cols-3 gap-12 sm:gap-36">
        {/* Left: Initials & Quote */}
        <div className="flex flex-col items-center sm:items-start">
          <div className="flex space-x-2 mb-3">
            {/* B */}
            <svg width="40" height="40" viewBox="0 0 100 100">
              <rect width="100" height="100" fill="#f97316" />
              <text
                x="50"
                y="65"
                textAnchor="middle"
                fontSize="60"
                fontFamily="Arial, sans-serif"
                fill="white"
                stroke="white"
                strokeWidth="2"
                style={{ mixBlendMode: "destination-out" }}
              >
                B
              </text>
            </svg>

            {/* S */}
            <svg width="40" height="40" viewBox="0 0 100 100">
              <rect width="100" height="100" fill="#10b981" />
              <text
                x="50"
                y="65"
                textAnchor="middle"
                fontSize="60"
                fontFamily="Arial, sans-serif"
                fill="white"
                stroke="white"
                strokeWidth="2"
                style={{ mixBlendMode: "destination-out" }}
              >
                S
              </text>
            </svg>

            {/* P */}
            <svg width="40" height="40" viewBox="0 0 100 100">
              <rect width="100" height="100" fill="#6366f1" />
              <text
                x="50"
                y="65"
                textAnchor="middle"
                fontSize="60"
                fontFamily="Arial, sans-serif"
                fill="white"
                stroke="white"
                strokeWidth="2"
                style={{ mixBlendMode: "destination-out" }}
              >
                P
              </text>
            </svg>
          </div>

          <p className="text-sm text-gray-800 italic max-w-xs">
            "Code is like humor. When you have to explain it, it’s bad."
          </p>
        </div>

        {/* <div>
          <h3 className="text-3xl font-bold mb-2">BSP</h3>
          <p className="text-sm text-gray-800 italic">
            "Code is like humor. When you have to explain it, it’s bad."
          </p>
        </div> */}

        {/* Middle: Quick Links */}
        <div className="sm:pl-10 sm:mr-32 ">
          <h4 className="text-lg font-semibold mb-3">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li>
              {" "}
              <button
                onClick={() => navigate("/")}
                className="hover:underline text-left"
              >
                Home
              </button>
            </li>
            <li>
              {" "}
              <button
                onClick={() => navigate("/about")}
                className="hover:underline"
              >
                About Me
              </button>
            </li>
             <li>
              {" "}
              <button
                onClick={goToProjects}
                className="hover:underline text-left"
              >
                Project
              </button>
            </li>
            <li>
              {" "}
              <button
                onClick={() => navigate("/contact")}
                className="hover:underline"
              >
                Contact
              </button>
            </li>
          </ul>
        </div>

        {/* Right: Social Media */}
        <div className="flex flex-col sm:items-end">
          <h4 className="text-lg font-semibold mb-3">Connect with me</h4>
          <div className="flex items-center justify-center space-x-4 text-xl">
            <a
              href="https://github.com/yourusername"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-700"
            >
              <FaGithub />
            </a>
            <a
              href="https://linkedin.com/in/yourusername"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-700"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://twitter.com/yourusername"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-700"
            >
              <FaTwitter />
            </a>
            <a
              href="mailto:youremail@example.com"
              className="hover:text-gray-700"
            >
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-300 mt-8 pt-4 text-center text-sm">
        © {new Date().getFullYear()} Bibhu. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;

// import React from 'react'

// const Footer = () => {
//   return (
//     <div className='min-h-14 bg-[#c3f7f7] content-center'>
//       <div className='text-black flex items-center justify-center'>
//        <p>Made with <span className="heart">❤️</span> by <strong>Bibhu</strong></p>
//       </div>
//     </div>
//   )
// }

// export default Footer
